<template>
	<div>
		
		<h2>Inquilinos</h2>
		<br>
		<input type="text" v-model="abuscar" placeholder="Buscar">
		<br>
		<br>

		<ul id='inquilinos-lista' v-if="inquilinosTodos !=null" >
			<li v-for="inqui in buscando" align="left" >	

				<strong v-on:click="lanza(inqui.id, inqui.nombreCompleto, inqui.email, inqui.celular, inqui.telefonoFijo, inqui.whatsapp, inqui.facebook, inqui.dirCalle + ' ' + inqui.dirNumero + ' -' + inqui.dirInterior + ' ' + inqui.dirColonia + ' ' + inqui.dirCodigo  + ' ' + inqui.dirCiudad + ' ' + inqui.dirEstado, inqui.celular, inqui.fbInquilino, inqui.wappInquilino)">

					<p>Nombre: {{inqui.nombreCompleto}}</p>
					<p>Id: {{inqui.id}}</p>
					<p>Mail: {{inqui.email}}</p>
					<p>Celular: {{inqui.celular}}</p>
					<p>Calle: {{inqui.dirCalle}}</p>
					<p>Numero: {{inqui.dirNumero}}</p>
					<p>Interior: {{inqui.dirInterior}}</p>
					<p>Colonia: {{inqui.dirColonia}}</p>

				</strong>
				<br>
				<button type='button' v-on:click="lanza(inqui.id, inqui.nombreCompleto, inqui.email, inqui.celular, inqui.telefonoFijo, inqui.whatsapp, inqui.facebook, inqui.dirCalle + ' ' + inqui.dirNumero + ' -' + inqui.dirInterior + ' ' + inqui.dirColonia + ' ' + inqui.dirCodigo  + ' ' + inqui.dirCiudad + ' ' + inqui.dirEstado, inqui.celular, inqui.fbInquilino, inqui.wappInquilino)">Seleccionar</button>
			   	<p>
			   		<br>
					<router-link :to="{name: 'ver-inqui', params:{id:inqui.id}}">Ver</router-link>
					<router-link :to="{name: 'edi-inqui', params:{id:inqui.id}}">Editar</router-link>
			   	</p>
			   	<br>
			   	<br>
  			</li>
		</ul>
		<span v-else>Cargando inquilinos ...</span>
	</div>
</template>


<script>
import axios from 'axios';

export default {
  name: 'Inquilinos-buscar',

  mounted(){
  	this.getInquilinos();
  },

  data () {
    return {
      inquilinosTodos: null,
      abuscar: ''
    }
  },

  methods:{	
  	lanza: function(idInq, nombre1, email, celular, telefonoFijo, facebook, dirI, celI, fbI, wappI){
	    	this.$emit('eventoI', idInq, nombre1, email, celular, telefonoFijo, facebook, dirI, celI, fbI, wappI);
  	},
  	getInquilinos(){
  		axios.get('https://www.directodo.com/Rentus/accesosdb/leeInquilinos.php')
  		     .then((respuesta) => {
  		     	this.inquilinosTodos = respuesta.data;
  			 });
  	}

  },

  computed:{
  	buscando: function(){
  		return this.inquilinosTodos.filter((item) =>
	  			    item.nombreCompleto.toUpperCase().includes(this.abuscar.toUpperCase())
	  			||  item.email.toUpperCase().includes(this.abuscar.toUpperCase())
	  			||  item.dirCiudad.toUpperCase().includes(this.abuscar.toUpperCase()) 
	  			||  item.id.includes(this.abuscar.toUpperCase())
	  		);
  	}

  }
}
</script>

<style lang="scss">
	#propiedades-lista{
		padding:20px;
		li{
			width: 100%;
			height: 120px;
			background: #eee;
			overflow: hidden;
		}
	}
</style>




// WEBPACK FOOTER //
// src/Inquilinos-buscar.vue